import React from 'react';
import { Form, Input, Select, Button, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const INDUSTRY_SECTORS = [
  'Education',
  'Energy',
  'Financial Services',
  'Government',
  'Healthcare',
  'Manufacturing',
  'Non-Profit',
  'Other',
  'Retail',
  'Technology',
  'Transportation'
];

const TIMEZONES = [
  'Australia/Sydney',
  'Australia/Melbourne',
  'Australia/Brisbane',
  'Australia/Perth',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Australia/Hobart',
  'Pacific/Auckland',
  'Asia/Singapore',
  'Asia/Tokyo',
  'America/New_York',
  'Europe/London'
];

const SUBSCRIPTION_PLANS = [
  { value: 'business-pro', label: 'Business Pro' },
  { value: 'enterprise-pro', label: 'Enterprise Pro' }
];

export default function OrganisationInfo({ form }) {
  return (
    <div>
      <Form.Item
        name="name"
        label="Organisation Name"
        rules={[{ required: true, message: 'Please enter organisation name' }]}
      >
        <Input placeholder="Enter organisation name" />
      </Form.Item>

      <Form.Item
        name="subscriptionPlan"
        label="Subscription Plan"
        rules={[{ required: true, message: 'Please select a subscription plan' }]}
        tooltip={{
          title: 'Select the subscription plan for this organisation',
          icon: <QuestionCircleOutlined />
        }}
      >
        <Select
          placeholder="Select subscription plan"
          options={SUBSCRIPTION_PLANS.map(plan => ({
            value: plan.value,
            label: plan.label
          }))}
        />
      </Form.Item>

      <Form.Item
        name="industry"
        label="Industry Sector"
        rules={[{ required: true, message: 'Please select industry sector' }]}
      >
        <Select
          placeholder="Select industry sector"
          options={INDUSTRY_SECTORS.map(sector => ({ value: sector, label: sector }))}
        />
      </Form.Item>

      <Form.Item
        name="description"
        label="Organisation Description"
        rules={[{ required: true, message: 'Please enter organisation description' }]}
      >
        <Input.TextArea
          placeholder="Enter organisation description"
          rows={4}
        />
      </Form.Item>

      <Form.Item
        name="abn"
        label="ABN or Legal Entity"
        rules={[{ required: true, message: 'Please enter your ABN or legal entity' }]}
      >
        <Input placeholder="Enter your ABN or legal entity" />
      </Form.Item>

      <Form.Item
        name="primaryAddress"
        label="Primary Business Address"
        rules={[{ required: true, message: 'Please enter your primary business address' }]}
      >
        <Input.TextArea 
          placeholder="Enter your primary business address"
          rows={3}
        />
      </Form.Item>

      <Form.List name="additionalLocations">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                <Form.Item
                  {...restField}
                  name={[name, 'address']}
                  rules={[{ required: true, message: 'Missing address' }]}
                >
                  <Input.TextArea 
                    placeholder="Additional location address"
                    rows={2}
                  />
                </Form.Item>
                <MinusCircleOutlined onClick={() => remove(name)} />
              </Space>
            ))}
            <Form.Item>
              <Button 
                type="dashed" 
                onClick={() => add()} 
                block 
                icon={<PlusOutlined />}
              >
                Add Location
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>

      <Form.Item
        name="timezone"
        label="Timezone"
        rules={[{ required: true, message: 'Please select your timezone' }]}
        tooltip="This will be used for all incident timestamps and notifications"
      >
        <Select placeholder="Select your timezone">
          {TIMEZONES.map(timezone => (
            <Select.Option key={timezone} value={timezone}>
              {timezone.replace('_', ' ')}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  );
} 